import React from 'react';
import PropTypes from 'prop-types';

const StarIcon = ({ width, height, fill, stroke }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 17.324 17.321">
        <g>
            <path d="M3.995 10.616a.8.8 0 01.217.691l-.759 4.437a.781.781 0 00.285.743.7.7 0 00.763.068l3.8-2.13a.712.712 0 01.7 0l3.8 2.13a.7.7 0 00.777-.054.781.781 0 00.288-.757l-.751-4.44a.8.8 0 01.217-.691l3.108-3.124a.792.792 0 00.187-.791.743.743 0 00-.6-.521l-4.265-.614a.743.743 0 01-.562-.424l-1.879-4.06a.72.72 0 00-1.317 0L6.125 5.144a.742.742 0 01-.576.424l-4.254.612a.743.743 0 00-.6.522.792.792 0 00.188.79z" fill={fill} stroke={stroke} strokeWidth="1.3" />
        </g>
    </svg>
);

StarIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string,
    stroke: PropTypes.string
};

StarIcon.defaultProps = {
    width: '17.324',
    height: '17.321',
    fill: 'none',
    stroke: '#4b254e'
};

export default StarIcon;
